import axios from 'axios';

export default {
  state: {
    favoriteAddError: null,
    favoriteAddLoading: false
  },
  mutations: {
    SET_FAVORITE_LOADING(state, status) {
      state.favoriteAddLoading = status;
    },
    SET_FAVORITE_ERROR(state, error) {
      state.favoriteAddError = error;
    },
  },
  actions: {
    async addToFavorite({ commit, state, dispatch }, productId) {
      try {
        //commit('SET_FAVORITE_LOADING', true);

        const response = await axios.post('api/catalog/favorite/', {id: productId}, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data && response.data.status === 'success') {
          if (response.data.data=='add')
          commit('ADD_FAVORITE', productId);
          else
            commit('REMOVE_FAVORITE', productId);
          dispatch('fetchCounterData', true);
        } else {
          throw new Error(response.data.message || 'Ошибка при обновлении избранного');
        }

        commit('SET_FAVORITE_ERROR', null);
      } catch (error) {
        commit('SET_FAVORITE_ERROR', error.message || 'Ошибка при обновлении избранного');
        console.error('Error updating favorites:', error);
      } finally {
        //commit('SET_FAVORITE_LOADING', false);
      }
    },
    async addToBasket({ commit, state, dispatch }, {productId:productId, quantity:quantity, collection: collection}) {
      try {
        //commit('SET_FAVORITE_LOADING', true);

        const response = await axios.post('api/basket/add/', {id: productId,
          collection: collection,
          quantity: quantity}, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data && response.data.status === 'success') {
          if (response.data.data)
            commit('ADD_BASKET', productId);

          dispatch('fetchCounterData', true);
        } else {
          throw new Error(response.data.message || 'Ошибка при обновлении избранного');
        }

        commit('SET_FAVORITE_ERROR', null);
      } catch (error) {
        commit('SET_FAVORITE_ERROR', error.message || 'Ошибка при обновлении избранного');
        console.error('Error updating favorites:', error);
      } finally {
        //commit('SET_FAVORITE_LOADING', false);
      }
    }
  },
  getters: {
    favoriteAddLoading: state => state.favoriteAddLoading,
    favoriteAddError: state => state.favoriteAddError,
    isFavorite: state => productId => state.favorites.includes(productId)
  }
}
